import React from 'react'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Button, IconButton } from '@mui/material'
import { useParams, Link } from 'react-router-dom'
import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import usePrescriptionStore from '../DataRepository/Prescription'
import axios from "axios"
import AddIcon from '@mui/icons-material/Add';
import { Dialog, DialogTitle, DialogActions } from "@mui/material";

import io from 'socket.io-client'
import SendIcon from '@mui/icons-material/Send';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import AudioWave from './AudioWave'
import Lottie from 'lottie-react'
import typinganimation from '../Assets/animations/typinganimation.json'

function Chat({ currentChat }) {
    let [msg, setmsg] = useState('')
    const textAreaRef = useRef(null);

    let { patient_id, doctor_uid, doctor_id, Appointment_id } = currentChat

    Appointment_id = 'Appointment_1736768872477'

    patient_id = '81b34d3a-60b1-70a2-7713-f4a199ce2da9'

    const [open, setOpen] = useState(false);
    const fileInputRef = useRef(null);

    // Open dialog
    const handleOpen = () => {
        setOpen(true);
    };

    // Close dialog
    const handleClose = () => {
        setOpen(false);
    };

    // Handle user choice
    const handleFileSelection = (type) => {
        if (type === "image") {
            fileInputRef.current.accept = "image/*";
        } else {
            fileInputRef.current.accept = "application/pdf";
        }
        fileInputRef.current.click(); // Trigger file input
        handleClose(); // Close the dialog
    };

    // Handle file selection
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            console.log("Selected file:", file);
            
        }
    };


    // console.log(doctor_uid, doctor_id)

    const [online, setOnline] = useState([])

    let [messages, setmessages] = useState([])

    const WS_URL = `wss://a7uoyq8x2j.execute-api.ap-south-1.amazonaws.com/production/?userId=${doctor_id}`;

    let [arrivalMessage, setArrivalMessage] = useState(null);

    let scrollRef = useRef();
    const socket = useRef();

    const sendIconStyle = {
        width: '3rem',
        height: '3rem',
        display: 'flex',
        padding: '5px',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--themePrimaryColor, #DA6E0B)',
        color: 'white',
    };

    const addIconStyle = {
        width: '3rem',
        height: '3rem',
        display: 'flex',
        padding: '5px',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '5px',
        color: 'var(--themePrimaryColor, #DA6E0B)'
    };

    useEffect(() => {
        socket.current = io('https://z2t1vcmobj.execute-api.ap-south-1.amazonaws.com/dev');
        socket.current.emit("add-user", doctor_id);
        socket.current.on("get-users", (users) => {
            setOnline(users)
        });
    }, [currentChat])

    const { sendJsonMessage, lastJsonMessage, readyState } =
        useWebSocket(WS_URL, {
            onOpen: () => {
                console.log("WebSocket connection established.");
            },
            share: false,
            shouldReconnect: () => true,
        });

    useEffect(() => {
        if (readyState === ReadyState.OPEN) {
            sendJsonMessage({
                event: "subscribe",
                data: {
                    channel: "general-chatroom",
                },
            });
        }
    }, [readyState]);


    useEffect(() => {
        if (lastJsonMessage) {
            console.log(`Got a new message: ${lastJsonMessage}`);
            const { event, data } = lastJsonMessage;
            arrivalMessage && setmessages((prev) => [...prev, arrivalMessage]);
        }
    }, [lastJsonMessage, currentChat]);


    const sendChat = () => {
        if (msg.trim() === '') return;

        sendJsonMessage({
            action: "sendMessage",
            message: msg,
            type: "text",
            from: doctor_id,
            to: patient_id,
            conversationId: `${currentChat?.Appointment_id}`,
        });

        setmsg('');
    };


    let Collectmsgs = async () => {
        try {
            const res = await axios.post('https://z2t1vcmobj.execute-api.ap-south-1.amazonaws.com/dev/getMessages', {
                conversationId: currentChat?.Appointment_id
            });

            if (res.status === 200) {
                setmessages(res.data);
            }

        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        Collectmsgs()
    }, [lastJsonMessage, currentChat]);

    const resizeTextArea = () => {
        textAreaRef.current.style.height = "20px";
        textAreaRef.current.style.height = textAreaRef.current.scrollHeight + "px";
    };

    useEffect(
        resizeTextArea,
        [msg]);


    useEffect(() => {
        arrivalMessage && setmessages((prev) => [...prev, arrivalMessage]);
    }, [arrivalMessage]);

    useEffect(() => {
        scrollRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    return <div className='chat-box border-[1px] border-neutral-300'>
        <div className='chat-head'>
            <div>

                <div className='flex flex-row p-2 ' style={{ borderRadius: "8px" }}>
                    <p>{currentChat?.patient_name}</p>
                </div>
                <div className='p-2 pt-1 typing-text'>
                    {
                        lastJsonMessage?.from === patient_id && lastJsonMessage?.event === 'typing' &&
                        <p>typing...</p>
                    }
                </div>
            </div>
        </div>
        <div className='chat-body ' ref={scrollRef}>
            {
                messages.map((e, i) => {
                    return <div
                        key={i}
                        className={e?.from === doctor_id ? "message own" : "message"}
                    >
                        <span>{e.type === "image" ? <img src={e.message}></img>
                            : e.type === "audio" ? <AudioWave audioUrl={e.message} /> :
                                e.message
                        }
                        </span>
                    </div>
                })

            }

            {
                lastJsonMessage?.from === patient_id && lastJsonMessage?.event === 'typing' &&
                <div className='typinganimation-container'>
                    <Lottie animationData={typinganimation}></Lottie>
                </div>
            }

        </div>
        <div className='chat-footer'>
            <div className='chat-footer-action-inputs flex flex-row'>
                <div className='chat-footer-textarea'>
                    <textarea ref={textAreaRef} placeholder="Message..." value={msg} style={{ color: "black" }}
                        type='text' onChange={(e) => { setmsg(e.target.value) }} row="1" />
                </div>

                <div className='chat-icons'>
                    <Button style={addIconStyle} onClick={handleOpen}>
                        <AddIcon />
                    </Button>

                    {/* Hidden file input */}
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                    />

                    {/* Dialog Box */}
                    <Dialog open={open} onClose={handleClose}>
                    <DialogTitle style={{ textAlign: 'center' }}>Select</DialogTitle>
                        <DialogActions
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start', 
                            padding: '8px', 
                        }}
                        >
                        <Button
                            onClick={() => handleFileSelection("image")}
                            color="primary"
                            style={{ display: 'flex', alignItems: 'center' }} 
                        >
                            <img
                            src="./icons/Image icon.png"
                            className="w-6 h-6 mr-2 object-fill"
                            alt="Image Icon"
                            />
                            Upload Image
                        </Button>
                        <Button
                            onClick={() => handleFileSelection("pdf")}
                            color="secondary"
                            style={{ display: 'flex', alignItems: 'center' }}
                        >
                            <img
                            src="./icons/pdf icon.png"
                            className="w-6 h-6 mr-2 object-fill"
                            alt="PDF Icon"
                            />
                            Upload PDF
                        </Button>
                        </DialogActions>

                    </Dialog>

                    {msg.length > 1 && (
                        <Button style={sendIconStyle} onClick={sendChat}>
                            <SendIcon style={{ color: "#da6e0v" }} fontSize='small' />
                        </Button>
                    )}
                </div>

            </div>

        </div>
    </div>







}

export default Chat